<template>
  <div>
    <v-dialog
      v-model="dialog"
    >
      <v-card>
        <v-card-title>
          AJOUTER CONTEXTE PARTENAIRE
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="2">
              <v-text-field v-model="reference" hide-details dense outlined label="code ayant droit" @keyup.enter="searchByReference()">
                <v-icon slot="append">mdi-magnify</v-icon>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field v-model="keyword" hide-details dense outlined label="code" @keyup.enter="searchByKeyword()">
                <v-icon slot="append">mdi-magnify</v-icon>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-text-field v-model="name" hide-details dense outlined label="partenaire" @keyup.enter="searchByName()">
                <v-icon slot="append">mdi-magnify</v-icon>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <v-data-table
            v-if="searched && !loading"
            v-model="selectedItem"
            single-select
            show-select
            item-key="key"
            :headers="headers"
            :items="iresaContexts"
            :item-class="getRowDisabledClass"
          >
            <template slot="item.data-table-select" slot-scope="{ item, isSelected, select }">
              <v-simple-checkbox
                :value="isSelected"
                :disabled="item.isDeactivated"
                @input="select($event)"
              />
            </template>
          </v-data-table>

          <div v-if="!searched && !loading" class="search-placeholder" style="display: flex; align-items: center; justify-content: center; font-weight: bold;">
            <div>
              <v-icon style="color: #ccc;" size="128">mdi-magnify</v-icon>
              <p class="mt-6" style="width: 100%;">Make a search by "code ayant droit" or "partenaire"</p>
            </div>
          </div>
          <div v-if="loading">
            <v-skeleton-loader
              class="mx-auto"
              type="table: table-heading, table-thead, table-tbody"
            />
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!selectedItem.length"
            color="secondary"
            elevation="0"
            class="mr-2 pl-3 pr-5"
            large
            @click="openPopupAddExistIresaCode"
          >
            <v-icon class="pr-1">mdi-plus</v-icon>
            Ajouter un contexte existant
          </v-btn>

          <v-btn
            :disabled="!selectedItem.length"
            color="secondary"
            elevation="0"
            class="mr-2 pl-3 pr-5"
            large
            @click="createNewContext"
          >
            <v-icon class="pr-1">mdi-plus</v-icon>
            Créer un nouveau contexte
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Modal v-if="dialogAddIresaCode" max-width="900" :show.sync="dialogAddIresaCode" :close="closeContextModal">
      <template #title>
        <div class="col-12 d-flex justify-center m-0 p-0">
          <v-card-title>
            AJOUTER EXISTANT CONTEXTE PARTENAIRE {{ selectedItem[0].name }}
          </v-card-title>
        </div>
      </template>
      <template #text>
        <v-card-text class="text-center" />
        <v-text-field
          v-model="newIresaId"
          :label="`Identité d'Iresa à partir du contexte  ${selectedItem[0].name} `"
          type="number"
          min="1"
          hide-details
          dense
        />
      </template>
      <template #actions>
        <v-card-actions class="d-flex col-12 justify-end">
          <v-spacer />
          <v-btn
            :disabled="!selectedItem.length"
            color="secondary"
            elevation="0"
            class="mr-2 pl-3 pr-5"
            large
            @click="addIresaIdToContext()"
          >
            <v-icon class="pr-1">mdi-plus</v-icon>
            Ajouter
          </v-btn>
          <v-btn
            :disabled="selectedItem.length != 1"
            color="secondary"
            elevation="0"
            class="mr-2 pl-3 pr-5"
            large
            @click="closeDialogAddIresaCode()"
          >
            <v-icon class="pr-1">mdi-minus</v-icon>
            Fermer
          </v-btn>
        </v-card-actions>
      </template>
    </Modal>
  </div>
</template>
<script>
import { EventBus } from '../../mixins';
import { requests } from '@/mixins/index';
import Modal from '@/components/Modal/Modal';

export default {
  components: { Modal },
  mixins: [requests],
  props: ['addContextToUser', 'addExistIresaIdToUser'],
  data () {
    return {
      dialog: false,
      dialogAddIresaCode: false,
      newIresaId: null,
      reference: null,
      name: null,
      keyword: null,
      loading: false,
      searched: false,
      selectedItem: [],
      abortController: null,
      customerContextList: [],
      headers: [
        { text: 'Code ayant droit', value: 'reference' },
        { text: 'Code', value: 'keyword' },
        { text: 'Partenaire', value: 'name' },
        { text: 'Type', value: 'type' }
      ],
      iresaContexts: []
    };
  },
  mounted () {
    EventBus.$on('showPartnerSearch', customerContextList => {
      this.startSearchModal(customerContextList);
    });
    EventBus.$on('openPopupAddExistIresaCode', context => {
      this.selectedItem.push({ name: context === 'speedboat' ? 'Vacances' : 'LaBalaguere', context: context });
      this.openPopupAddExistIresaCode(context);
    });
  },
  methods: {
    closeDialogAddIresaCode () {
      this.dialogAddIresaCode = false;
      this.newIresaId = null;
      this.selectedItem = [];
    },
    addIresaIdToContext () {
      this.addExistIresaIdToUser(this.selectedItem[0].context, this.newIresaId);
    },
    closeContextModal () {
      this.dialogAddIresaCode = false;
    },
    openPopupAddExistIresaCode () {
      this.dialogAddIresaCode = true;
    },
    createNewContext () {
      this.dialog = false;

      this.addContextToUser(this.selectedItem[0].context, {
        name: this.selectedItem[0].name,
        type: this.selectedItem[0].type,
        agencyKey: this.selectedItem[0].key,
        keyword: this.selectedItem[0].keyword,
        reference: this.selectedItem[0].reference
      });
    },
    startSearchModal (customerContextList) {
      this.dialog = true;
      this.reference = null;
      this.name = null;
      this.keyword = null;
      this.selectedItem = [];
      this.iresaContexts = [];
      this.searched = false;
      this.customerContextList = customerContextList;
    },
    searchByKeyword () {
      if (this.keyword) {
        this.search(null, null, this.keyword);
      }
    },
    searchByName () {
      if (this.name) {
        this.search(null, this.name, null);
      }
    },
    searchByReference () {
      if (this.reference) {
        this.search(this.reference, null, null);
      }
    },
    getRowDisabledClass (item) {
      return item.isDeactivated ? 'disabled-row' : '';
    },
    async search (reference, name, keyword) {
      this.loading = true;

      if (this.abortController) {
        this.abortController.abort();
      }

      this.abortController = new AbortController();

      this.selectedItem = [];
      const responseSearchIresa = await this.searchIresaContexts({ reference: reference, name: name, keyword: keyword });

      if (!responseSearchIresa.success) {
        this.loading = false;
        this.searched = true;
      }

      if (responseSearchIresa.success) {
        const { agencies } = responseSearchIresa.data;

        if (agencies && agencies.length) {
          this.iresaContexts = agencies;
        } else {
          this.iresaContexts = [];
        }
        this.loading = false;
        this.searched = true;
      }
    }
  }
};
</script>
<style>
.search-placeholder {
  min-height: 200px;
  text-align: center;
}

.disabled-row {
  opacity: 0.5;
  background-color: #f5f5f5;
}
</style>
